module.exports = function() {
  return new Worker("/" + "monaco-linter.d59decd4.worker.js");
};